// extracted by mini-css-extract-plugin
export var offer = "style-module--offer--c8d83";
export var offer__block = "style-module--offer__block--5bea6";
export var offer__item = "style-module--offer__item--a60dc";
export var offer__list1 = "style-module--offer__list-1--2329b";
export var offer__list2 = "style-module--offer__list-2--10b27";
export var offer__subtitle = "style-module--offer__subtitle--159a3";
export var offer__wrapper = "style-module--offer__wrapper--d8e76";